<template>
  <div class="goods-card">
    <div class="goods-image">
      <div class="is-single" v-if="item.adType == 1">单品</div>
      <el-image
        v-if="item.mainUrl"
        :src="item.mainUrl"
        class="goods-cover"
        fit="fill"
      />
      <div v-else class="cover-placeholder">暂无图片</div>
      <!-- <div class="goods-overlay">
        <el-button class="token-button" type="primary" @click="copyToken(item)"
          >复制下单链接</el-button
        >
      </div> -->
    </div>
    <div class="goods-info">
      <div class="shop-name">
        <div style="flex: 1; overflow: hidden">
          <el-tag
            style="
              font-size: 14px;
              font-weight: 600;
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
            "
            :title="item.authorName"
            >{{ item.authorName }}</el-tag
          >
        </div>

        <el-tag
          effect="dark"
          type="danger"
          style="margin-left: 10px; font-weight: 600; flex-shrink: 0"
          >{{ 100 - item.commissionRate }}折</el-tag
        >
      </div>

      <div class="goods-title" :title="item.title">
        <el-tag v-if="item.brand" size="small" type="info">{{
          item.brand
        }}</el-tag>
        {{ item.title }}
      </div>
      <div class="goods-brand">
        <div style="display: flex; align-items: center" v-if="!isFinished">
          距离活动结束还有:
          <el-statistic
            :value="timeData(item.expireTime)"
            format="D天H时m分s秒"
            :class="{ redColor: item.isRed }"
            time-indices
            title=""
            @finish="timeFinish"
          >
          </el-statistic>
        </div>
        <div class="finish-overlay" v-else>活动已结束，链接已失效</div>
        <!-- {{ item.expireTime }} -->
      </div>
      <div
        class="goods-price"
        :class="{ 'goods-price-mini': item.price > 100000 }"
      >
        <template v-if="item.adType == 2">
          <div class="price">
            <div>{{ fenToYuan(item.price) }}</div>
            <span>价格</span>
          </div>
          <div class="price">
            <div>{{ item.commissionRate }}%</div>
            <span>平台补贴</span>
          </div>
          <div class="price">
            <div>{{ 100 - item.commissionRate }}折</div>
            <span>到手折扣</span>
          </div>
        </template>
        <template v-else>
          <div class="price">
            <div>{{ fenToYuan(item.price) }}</div>
            <span>原价</span>
          </div>
          <div class="price">
            <div>{{ item.commissionRate }}%</div>
            <span>平台补贴</span>
          </div>
          <div class="price">
            <div>
              {{
                fenToYuan(item.price * (100 - item.commissionRate) / 100)
              }}
            </div>
            <span>到手价</span>
          </div>
        </template>
      </div>
    </div>
    <div class="shop-tips">
      <span v-if="item.adType == 2">*该直播间下单，所有商品均享{{ 100 - item.commissionRate }}折</span>
      <span v-else>*该商品为单品，享{{100-item.commissionRate}}折</span>
      <el-button
        class="token-button"
        plain
        size="small"
        type="primary"
        @click="copyToken(item)"
        >复制链接</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Goods",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isFinished: false,
      deadline2: Date.now() + 1000 * 60 * 60 * 8,
    };
  },
  computed: {
    timeData() {
      return (date) => {
        return new Date(date);
      };
    },
  },
  mounted() {},
  methods: {
    fenToYuan(fen) {
      const n = Number(fen || 0);
      return (n / 100).toFixed(2);
    },
    async copyToken(item) {
      const content = `${item.shopName}[所有商品均${
        100 - item.commissionRate
      }折]\n下单点击${item.wechatUrl}`;
      const textarea = document.createElement("textarea");
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("复制成功");
      } catch (e) {
        this.$message.error("复制失败");
      }
      document.body.removeChild(textarea);
    },
    // timeChange(data){
    //   console.log(new Date(data.expireTime)-Date.now()<1000*60*60*12)
    // },
    timeFinish() {
      this.isFinished = true;
    },
  },
};
</script>

<style scoped>
.goods-card {
  background: #fff;
  overflow: hidden;
  margin-bottom: 16px;
  transition: all 0.3s;
  border: 1px solid #d7d7d7;
  display: flex;
  align-items: center;
  position: relative;
}
.goods-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.goods-image {
  padding: 18px 12px;
  position: relative;
  overflow: hidden;
}
.is-single {
  width: 100px;
  height: 60px;
  font-size: 14px;
  color: #fff;
  background-color: #409eff;
  transform: rotateZ(-45deg);
  position: absolute;
  left: -52px;
  top: -33px;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.goods-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}
.shop-name {
  display: flex;
}
.goods-card:hover .goods-overlay {
  opacity: 1;
  z-index: 1;
}
.goods-brand >>> .number {
  font-size: 12px;
  color: #409eff;
}
.finish-overlay,
.redColor >>> .number {
  color: #f56c6c;
}
.goods-card:hover .shop-tips {
  color: #aaa;
}
.token-button {
  z-index: 1;
  margin-left: 12px;
}

.goods-cover {
  width: 180px;
  height: 180px;
  display: block;
  flex-shrink: 0;
}
.cover-placeholder {
  width: 180px;
  height: 180px;
  background: #f2f3f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}
.goods-info {
  padding-right: 8px;
  padding-bottom: 30px;
  flex: 1;
  overflow: hidden;
}
.shop-tips {
  position: absolute;
  font-size: 12px;
  color: #bbb;
  bottom: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
}
.goods-title {
  font-size: 14px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.5;
  margin-top: 8px;
  font-weight: 600;
}
.goods-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  padding: 8px 0;
}
.goods-brand >>> .el-statistic {
  width: auto;
}

.goods-meta {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}
.brand {
  background: #f0f2f5;
  color: #606266;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.category {
  background: #ecf5ff;
  color: #409eff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.shop {
  padding: 2px 0px;
  font-size: 14px;
}
.shop-info {
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}
.shop-info img {
  width: 26px;
  height: 26px;
  margin-right: 4px;
}
.goods-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
}
.price {
  color: #f56c6c;
  font-size: 16px;
  padding: 2px 8px;
  text-align: center;
  border-radius: 4px;
  line-height: 24px;
}
.goods-price-mini .price {
  font-size: 13px;
}
.price div {
  font-weight: 700;
}
.price span {
  font-size: 12px;
  color: #606266;
}
.commission {
  color: #67c23a;
  font-size: 16px;
}
</style>
